var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.192 0.101622L14.76 7.73462C14.8836 7.80425 14.9865 7.9055 15.058 8.02798C15.1296 8.15045 15.1673 8.28976 15.1673 8.43162C15.1673 8.57348 15.1296 8.71279 15.058 8.83527C14.9865 8.95775 14.8836 9.05899 14.76 9.12862L1.192 16.7616C1.07022 16.8301 0.932636 16.8654 0.792939 16.8642C0.653243 16.863 0.516305 16.8252 0.395751 16.7546C0.275198 16.684 0.175231 16.5831 0.105799 16.4618C0.0363677 16.3406 -0.000108409 16.2033 2.4202e-07 16.0636V0.799622C6.61928e-05 0.660005 0.0366697 0.522837 0.106173 0.401749C0.175676 0.280662 0.275659 0.179872 0.396183 0.109398C0.516708 0.038923 0.653578 0.00121762 0.793189 2.89996e-05C0.932801 -0.00115962 1.07029 0.03321 1.192 0.101622Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.086821577ee2771e4ae52b562a1411cf.svg";
export { ForwardRef as ReactComponent };